import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Capacitor } from '@capacitor/core';

import cccLogo from '../../assets/ccc-logo.png';
import { APP_STORE_LINKS } from '../../constants/appStoreLinks';
import { v2Colors, v2DisplayFontFamily } from '../design/theme';

function storeUrlForPlatform() {
  const platform = Capacitor.getPlatform();
  if (platform === 'android') return APP_STORE_LINKS.android;
  return APP_STORE_LINKS.ios;
}

function storeLabelForPlatform() {
  const platform = Capacitor.getPlatform();
  if (platform === 'android') return 'Update on the Play Store';
  return 'Update on the App Store';
}

/**
 * Full-screen blocking gate — no dismiss; user must update native app from the store.
 */
export default function ForceNativeUpdateModal({
  message,
  installedVersion,
  installedBuild,
}) {
  const openStore = () => {
    window.open(storeUrlForPlatform(), '_system');
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 20000,
        bgcolor: v2Colors.canvas,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        py: 4,
      }}
    >
      <Box
        component="img"
        src={cccLogo}
        alt="Country Chicken Co"
        sx={{ width: 'max-content', maxWidth: '70vw', mb: 3 }}
      />
      <Typography
        sx={{
          fontFamily: v2DisplayFontFamily,
          color: v2Colors.primary,
          fontSize: { xs: 22, sm: 26 },
          fontWeight: 700,
          textAlign: 'center',
          mb: 2,
        }}
      >
        Update required
      </Typography>
      <Typography
        sx={{
          color: 'text.secondary',
          fontSize: 16,
          textAlign: 'center',
          maxWidth: 400,
          mb: 3,
          lineHeight: 1.5,
        }}
      >
        {message}
      </Typography>
      {installedVersion ? (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Your app version: {installedVersion}
          {installedBuild ? ` (${installedBuild})` : ''}
        </Typography>
      ) : null}
      <Button
        variant="contained"
        size="large"
        onClick={openStore}
        sx={{
          bgcolor: v2Colors.primary,
          px: 4,
          py: 1.25,
          fontSize: 16,
          '&:hover': { bgcolor: v2Colors.primaryDark },
        }}
      >
        {storeLabelForPlatform()}
      </Button>
    </Box>
  );
}
